<template>
  <div class="title-bar clearfix">

    <div slot="header" class="clearfix">
      <div class="module pull-left">
        {{ $t("CodeScanningInformation") }}
      </div>

      <div class="btn-group pull-right">

        <el-button plain size="mini" @click="addEAN" v-if="canEdit">{{ $t("add") }}
          <i class="fa fa-plus"></i>
        </el-button>

        <el-button plain size="mini" @click="refresh">{{ $t("refresh") }}
          <i class="fa fa-refresh"></i>
        </el-button>
        <el-button plain size="mini" @click="searchDialogVisible=true">{{ $t("search") }}
          <i class="fa fa-search"></i>
        </el-button>

      </div>
    </div>
    <div class="data-list" v-loading="loading" element-loading-text="Loading">
      <el-table class="customer-table" border stripe :data="CodeScanningData" size="mini">
        <el-table-column v-if="canEdit" label="操作" align="center" width="180" :resizable="true">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">{{$t("edit")}}</el-button>
            <el-button size="mini" type="text" @click="handleDelete(scope.$index, scope.row)">{{$t("delete")}}</el-button>
          </template>
        </el-table-column>

        <el-table-column prop="ScanningTimes" :label="this.$t('ScanningTimes')" header-align="center" align="center">
          <template slot-scope="scope">
            {{friendlyScanTimes(scope.row.ScanningTimes)}}
          </template>
        </el-table-column>
        <el-table-column prop="ScanningMessage" :label="this.$t('ScanningMessage')" header-align="center" align="center">
        </el-table-column>

      </el-table>
      <el-row style="margin-top:10px;">
        <el-pagination style="float:right" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[15,30,50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </el-row>

      <el-dialog class="search-dialog" :title="this.$t('search')" :visible.sync="searchDialogVisible" width="45%">

        <el-form :model="filter" class="search-form" :inline="true" size="small">
          <el-form-item :label="this.$t('ScanningTimes')" size="small" :label-width="searchDialogLabelWidth">
            <div @keyup="handlekeyup($event)">
              <el-input v-model="filter.ScanningTimes" auto-complete="off"></el-input>
            </div>
          </el-form-item>

          <el-form-item :label="this.$t('ScanningMessage')" size="small" :label-width="searchDialogLabelWidth">
            <el-input v-model="filter.ScanningMessage" auto-complete="off"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align:center">
          <el-button @click="searchDialogVisible = false" :plain="true" size="mini">{{this.$t('cancel')}}</el-button>
          <el-button @click="resetFilter" :plain="true" size="mini">{{$t('reset')}}</el-button>
          <el-button type="primary" @click="search" :plain="true" size="mini">{{this.$t('confirm')}}</el-button>
        </div>
      </el-dialog>

    </div>
  </div>

</template>
<script>
import OperationHeader from "@/components/shared/OperationHeader";
import qs from "qs";
import _ from "lodash";
import { mapGetters } from "vuex";
import roleTypes from "../../../models/roleTypes";
import searchTypes from "../../../models/searchTypes";
import searchHistoryService from "../../../services/searchHistoryService";
export default {
  name: "CodeScanningInformation",
  components: { OperationHeader },
  data() {
    return {
      loading: true,
      filter: {
        ScanningTimes: "",
        ScanningMessage: ""
      },
      filterOptions: [],
      userTypeList: [],
      QRCTypeList: [],
      searchDialogLabelWidth: "120px",
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0,
      searchDialogVisible: false,
      CodeScanningData: []
    };
  },
  computed: {
    ...mapGetters(["roles", "permissions"]),
    canEdit() {
      return (
        this.roles.includes(roleTypes.Administrator) ||
        this.permissions.find(
          p =>
            p.toLowerCase() === "CodeScanningInformation.edit" ||
            p.toLowerCase() === "CodeScanningInformation.insert"
        )
      );
    }
  },
  created() {
    this.initializeFilter();
    this.obtainTableDataAccordingToConditions();
  },
  methods: {
    resetFilter() {
      this.filter = {
        CodeType: "",
        UserType: [],
        ScanningTimes: "",
        ScanningMessage: ""
      };
      this.filterOptions = [];
      searchHistoryService.removeHistory(searchTypes.CODESCANNING_HISTORY);
    },
    addEAN() {
      this.$router.push("addCodeScanningInformation");
    },
    handleEdit(index, row) {
      this.$router.push({
        name: "EditCodeScanningInformation",
        params: { Id: row.Id }
      });
    },
    userTypeSetup() {
      if (this.userTypeList == "") {
        for (var i = 2; i <= 4; i++) {
          this.userTypeList.push(i);
        }
        this.userTypeList.push(8);
      }
      if (this.QRCTypeList == "") {
        this.QRCTypeList.push(1);
        this.QRCTypeList.push(2);
      }
    },
    handleDelete(index, row) {
      this.$confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.deleteData(row.Id);
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.obtainTableDataAccordingToConditions();
      } else {
        this.pageIndex = 1;
      }
    },
    handlekeyup(event) {
      var father = event.currentTarget;
      var input = father.getElementsByTagName("input")[0];
      input.value = input.value.replace(/[^0-9]/g, "");
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.obtainTableDataAccordingToConditions();
    },

    obtainTableDataAccordingToConditions() {
      this.loading = true;
      this.$axios
        .get("api/codescanning/getall", {
          params: {
            filter: this.filtergenerator(),
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
          }
        })
        .then(response => {
          this.translateData(response.data.Data);
          this.loading = false;
          this.totalCount = response.data.TotalCount;
        });
    },

    deleteData(rowId) {
      this.$axios
        .get("api/codescanning/delete", {
          params: {
            Id: rowId
          }
        })
        .then(response => {
          this.$message({
            type: "success",
            message: "删除成功"
          });
          this.obtainTableDataAccordingToConditions();
        });
    },
    refresh() {
      this.pageIndex = 1;
      this.resetFilter();
      this.obtainTableDataAccordingToConditions();
    },

    initializeFilter() {
      let his = searchHistoryService.getHistory(
        searchTypes.CODESCANNING_HISTORY
      );
      if (his) {
        let keys = Object.keys(this.filter);
        his.forEach(h => {
          if (keys.includes(h.name)) {
            this.filter[h.name] = h.value;
          }
        });
        this.setFilterOptions();
      }
    },
    setFilterOptions() {
      this.filterOptions = [];
      Object.keys(this.filter).forEach(k => {
        let val = this.filter[k];
        if (typeof val === "number" || val) {
          this.filterOptions.push({ name: k, value: val });
        }
      });
    },
    search() {
      this.searchDialogVisible = false;
      this.setFilterOptions();
      searchHistoryService.setHistory(
        searchTypes.CODESCANNING_HISTORY,
        this.filterOptions
      );
      this.obtainTableDataAccordingToConditions();
    },
    translateData(data) {
      for (var i = 0; i < data.length; i++) {
        var utype = "UserType" + data[i].UserType;
        var codetype = "QRC" + data[i].CodeType;
      }
      this.CodeScanningData = data;
    },
    filtergenerator() {
      var filterOptions = [];

      if (
        this.filter.ScanningMessage !== null &&
        this.filter.ScanningMessage.trim() !== ""
      ) {
        var filterOption = {
          name: "ScanningMessage",
          value: this.filter.ScanningMessage
        };

        filterOptions.push(filterOption);
      }
      if (
        this.filter.ScanningTimes !== null &&
        this.filter.ScanningTimes.trim() !== ""
      ) {
        var filterOption = {
          name: "ScanningTimes",
          value: this.filter.ScanningTimes
        };

        filterOptions.push(filterOption);
      }

      return JSON.stringify(filterOptions);
    },
    friendlyScanTimes(times) {
      if (!times) {
        return `${times} (未找到产品号)`;
      }
      return times;
    }
  }
};
</script>

  
 



// WEBPACK FOOTER //
// src/components/application/CodeScanningInformation/CodeScanningInformation.vue